import React, { FC } from "react";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { CreateUpdateEntityFormValues } from "../../EntityEditor";

import { useGetCurrencies } from "@api";
import { FormControl, InputLabel, MenuItem, Select } from "@components/base";
import { useUserStore } from "@store/user";

interface Currency {
  control: Control<CreateUpdateEntityFormValues>;
}

const Currency: FC<Currency> = ({ control }) => {
  const { user } = useUserStore();
  const { currencies, currenciesEnabled } = useGetCurrencies(user);
  const { t } = useTranslation();

  return (
    currenciesEnabled && (
      <Controller
        control={control}
        name="currency"
        render={({ field }): React.ReactElement => (
          <FormControl fullWidth>
            <InputLabel>{t("entitiesManagement.entityEditor.currency")}</InputLabel>
            <Select
              {...field}
              fullWidth
              label={t("entitiesManagement.entityEditor.currency")}
            >
              {currencies?.map((currency) => (
                <MenuItem key={currency.id} value={currency.id}>
                  {currency.alphabeticCode}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      />
    )
  );
};

export default Currency;
